import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { colors, fontFamily, zIndex } from '../../ui/variables';

const EXAM_IMAGE_SIZE = 512;

const toolsListVariables = {
  main: { height: { iphone: 144 } },
};

export const EditToolStyle = styled.main`
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone +
    toolsListVariables.main.height.iphone}px
    0 0;
  width: 100%;

  .edit-tool-content {
    height: calc(
      100vh -
        (
          ${headerVariables.main.height.iphone +
          toolsListVariables.main.height.iphone}px
        )
    );

    .exam-images-container {
      background-color: ${colors.black};
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: 100%;

      .orignal-container,
      .classificated-container {
        flex-basis: 50%;
        height: 100%;
        position: relative;

        .images-wrapper {
          height: ${EXAM_IMAGE_SIZE}px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: ${EXAM_IMAGE_SIZE}px;

          .image-item {
            display: block;
            height: auto;
            max-height: 100%;
            max-width: 100%;
            opacity: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: auto;

            &.active {
              opacity: 1;
            }
          }

          .image-mask-item {
            opacity: 0;

            &.active {
              opacity: 1;
            }
          }
        }
      }

      .orignal-container {
        justify-content: flex-end;

        .images-wrapper {
          right: 0;

          .image-item {
            right: 0;
          }
        }
      }

      .classificated-container {
        justify-content: flex-start;
        position: relative;

        .images-wrapper {
          left: 0;

          .image-item {
            left: 0;
          }
        }

        .horizontal-guide,
        .vertical-guide {
          background-color: ${colors.white};
          position: absolute;
        }

        .horizontal-guide {
          height: 1px;
          left: 0;
          width: 100%;
        }

        .vertical-guide {
          height: 100%;
          top: 0;
          width: 1px;
        }

        .center-guide {
          border: solid 1px ${colors.white};
          border-radius: 50%;
          height: 20px;
          position: absolute;
          width: 20px;
        }
      }
    }
  }

  .save-modal-container {
    padding: 24px 40px 38px;
    width: 700px;

    .save-modal-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .save-modal-subtitle {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 48px;
    }

    .annotation-file-name {
      margin-bottom: 44px;

      .annotation-prefix {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGray};
        font-size: 14px;
        line-height: 18px;
      }

      .file-name-field {
        display: inline-block;
        padding-left: 8px;
        width: 204px;
      }
    }

    .actions-wrapper {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;

      .action-item {
        max-width: 188px;
        min-width: 188px;

        &:first-child {
          margin-right: 28px;
        }
      }
    }
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;
  }
`;
